<template>
    <div class="content">
      <div class="container-fluid">
        <div class="row">
    <b-modal
      id="modal-top-add-bulk"
      hide-footer
      title="Add Customer"
      content-class="shadow"
    >
    <!-- Loading Indicator -->
   <div v-if="loading" class="text-center mb-3">
    <b-spinner label="Loading..."></b-spinner>
    <p>Please wait while we upload your data.</p>
  </div>
      <!-- Modal Header -->
      <template #modal-header="{ close }">
        <h5>{{ translate('addBulkData') }}</h5>
        <p class="h5 mb-2">
          <b-icon
            icon="x-square"
            class="close-icon"
            @click="
              close();
              clearData();
            "
          ></b-icon>
        </p>
      </template>
  
      <!-- Download Sample File Button -->
      <b-row class="mb-3">
        <b-col md="12" class="text-center">
          <b-button
            variant="success"
            @click="downloadSampleFile"
          >
          {{ translate('downloadSampleFile') }}
          </b-button>
        </b-col>
      </b-row>
  
      <!-- File Upload Section -->
      <b-row>
        <b-col md="12">
          <label>{{ translate('uploadExcelFile') }}</label>
          <b-form-file
            v-model="file"
            @change="onFileSelected"
            ref="fileInput"
            accept=".csv, .xls, .xlsx"
            class="mb-2"
          ></b-form-file>
        </b-col>
      </b-row>
  
      <!-- Submit Button -->
      <b-row>
        <b-col md="12">
          <b-button
            variant="primary"
            @click="confirmAndSubmitFile"
            :disabled="loading" 
          >
          {{ translate('submit') }}
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
         <div class="row">
          <b-modal
              id="modal-top-add"
              hide-footer
              title="Add Customer"
              content-class="shadow" 
            >
              <template #modal-header="{ close }">
                <h5>{{ translate('addMember') }}</h5>
                <p class="h5 mb-2">
                  <b-icon
                    icon="x-square"
                    class="close-icon"
                    @click="
                      close();
                      clearData();
                    "
                  ></b-icon>
                </p>
              </template>
              <validation-observer ref="observer" v-slot="{ handleSubmit }">
                <b-form
                  class="text-left"
                  @submit.stop.prevent="handleSubmit(submitAddForm)"
                >
                  <b-row no-gutters>
                  
                    <b-col
                      md="12"
                      style="justify-content: center; align-items: center"
                    >
                      <Vinput
                        inputType="text"
                        :modelValue="addData.fullName"
                        @update:modelValue="
                          (newValue) => (addData.fullName = newValue)
                        "
                        :rules="{ required: true , regex:/^[a-zA-Z ]+$/}"
                        id="text-fullName"
                        name="text-fullName"
                        :label="translate('fullName')"
                        class="mb-1 mr-sm-2"
                        description="text-fullName-feedback"
                        validatorName="Full Name"
                      />
                    </b-col>
                     <b-col
                      md="12"
                      style="justify-content: center; align-items: center"
                    >
                      <Vinput
                        inputType="text"
                        :modelValue="addData.email"
                        @update:modelValue="
                          (newValue) => (addData.email = newValue)
                        "
                        :rules="{regex:/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/}"
                        id="text-email"
                        name="text-email"
                        :label="translate('email')"
                        class="mb-1 mr-sm-2"
                        description="text-email-feedback"
                        validatorName="Email"
                      />
                    </b-col>
                    <b-col
                      md="12"
                      style="justify-content: center; align-items: center"
                    >
                       <Vselect
                        :modelValue="addData.sex"
                        @update:modelValue="
                          (newValue) => (addData.sex = newValue)
                        "
                          :options="sexOptions"
                        :rules="{ required: true }"
                        id="text-sex"
                        name="text-rent-currency-options"
                        :label="translate('sex')"
                        class="mb-1 mr-sm-2 some-select"
                        description="text-sex-feedback"
                        validatorName="Sex"
                      />
                    </b-col>
                     <b-col
                      md="12"
                      style="justify-content: center; align-items: center"
                    >
                      <VinputGroup
                        inputType="text"
                        :modelValue="addData.phoneNumber"
                        @update:modelValue="
                          (newValue) => (addData.phoneNumber = newValue)
                        "
                        :rules="{ required: true, regex:/^\d{9}$/ }"
                        id="text-phoneNumber"
                        name="text-phoneNumber"
                        :label="translate('phoneNumber')"
                        class="mb-1 mr-sm-2"
                        description="text-phoneNumber-feedback"
                        validatorName="Phone Number"
                        prepend="+251"
                      />
                    </b-col>
                      <b-col
                      md="12"
                      style="justify-content: center; align-items: center"
                    >
                   <Vinput
                        inputType="text"
                        :modelValue="addData.address"
                        @update:modelValue="
                          (newValue) => (addData.address = newValue)
                        "
                        :rules="{ required: true }"
                        id="text-address"
                        name="text-address"
                       :label="translate('address')"
                        class="mb-1 mr-sm-2"
                        description="text-address-feedback"
                        validatorName="Address"
                      />
                     </b-col>
                     <b-col
                      md="12"
                      style="justify-content: center; align-items: center"
                    >
                   <Vinput
                        inputType="text"
                        :modelValue="addData.job"
                        @update:modelValue="
                          (newValue) => (addData.job = newValue)
                        "
                        :rules="{}"
                        id="text-job"
                        name="text-job"
                        :label="translate('job')"
                        class="mb-1 mr-sm-2"
                        description="text-job-feedback"
                        validatorName="Job"
                      />
                     </b-col>
                     <b-col
                      md="12"
                      style="justify-content: center; align-items: center"
                    >
                   <Vinput
                        inputType="text"
                        :modelValue="addData.idNumber"
                        @update:modelValue="
                          (newValue) => (addData.idNumber = newValue)
                        "
                        :rules="{}"
                        id="text-idNumber"
                        name="text-idNumber"
                        :label="translate('idNumber')"
                        class="mb-1 mr-sm-2"
                        description="text-idNumber-feedback"
                        validatorName="ID Number"
                      />
                     </b-col>
                     <!-- <b-col
                      md="12"
                      style="justify-content: center; align-items: center"
                    >
                   <Vinput
                        inputType="text"
                        :modelValue="addData.memberDescription"
                        @update:modelValue="
                          (newValue) => (addData.memberDescription = newValue)
                        "
                        :rules="{}"
                        id="text-description"
                        name="text-description"
                        :label="translate('memberDescription')"
                        class="mb-1 mr-sm-2"
                        description="text-description-feedback"
                        validatorName="Description"
                      />
                     </b-col> -->
                     <b-col  
                    md="12" style="justify-content: center; align-items: center">
                        <Vselect
                          :modelValue="addData.associationId"
                          @update:modelValue="(newValue) => { addData.associationId = newValue }"
                          :options="ekubTypeOptions"
                          :rules="{ required: true }"
                          id="text-ekubType"
                          name="text-ekubType"
                          :label="translate('selectTheAssociation')"
                          class="mb-1 mr-sm-2"
                          description="text-ekubType-feedback"
                          validatorName="Association Type"
                        />
                      </b-col>
                    <b-col
                      md="12"
                      style="justify-content: center; align-items: center"
                    >
                       <Vselect
                        :modelValue="addData.numberOfEkub"
                        @update:modelValue="
                          (newValue) => (addData.numberOfEkub = newValue)
                        "
                          :options="numberOfEkubOptions"
                        :rules="{ required: true }"
                        id="text-ekub-type-options"
                        name="text-ekub-type-options"
                        :label="translate('numberOfShare')"
                        class="mb-1 mr-sm-2 some-select"
                        description="text-ekub-type-options-feedback"
                        validatorName="Number Of Share"
                      />
                    </b-col>
                    <b-col
                        v-if="addData.ekubId !== null && addData.ekubId !== 0"
                        md="12"
                        style="justify-content: center; align-items: center"
                      >
                        <Vinput
                          inputType="text"
                          :modelValue="getEkubAmount*addData.amount"
                          :rules="{}"
                          id="text-ekubAmount"
                          name="text-ekubAmount"
                          :label="translate('amount')"
                          class="mb-1 mr-sm-2"
                          description="text-ekubAmount-feedback"
                          validatorName="Total Amount"
                          disabled
                        />
                      </b-col>
                    <b-col
                      md="12"
                      style="justify-content: center; align-items: center"
                    >
                   <Vinput
                        inputType="text"
                        :modelValue="addData.linkingDescription"
                        @update:modelValue="
                          (newValue) => (addData.linkingDescription = newValue)
                        "
                        :rules="{}"
                        id="text-description"
                        name="text-description"
                        :label="translate('associationLinkageDescription')"
                        class="mb-1 mr-sm-2"
                        description="text-description-feedback"
                        validatorName="Description"
                      />
                     </b-col>
                    <b-col class="mt-2">
                      <b-button type="submit" variant="primary">{{ translate('submit') }}</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </validation-observer>
            </b-modal>
        </div>
         <div class="row">
          <b-modal
              id="modal-top-EditCustomer"
              hide-footer
              title="Edit Customer"
              content-class="shadow" 
            >
              <template #modal-header="{ close }">
                <h5>{{ translate('editMember') }}</h5>
                <p class="h5 mb-2">
                  <b-icon
                    icon="x-square"
                    class="close-icon"
                    @click="
                      close();
                      clearData();
                    "
                  ></b-icon>
                </p>
              </template>
              <validation-observer ref="observer" v-slot="{ handleSubmit }">
                <b-form
                  class="text-left"
                  @submit.stop.prevent="handleSubmit(submitEditForm)"
                >
                  <b-row no-gutters>
                  
                    <b-col
                      md="12"
                      style="justify-content: center; align-items: center"
                    >
                      <Vinput
                        inputType="text"
                        :modelValue="selectedCustomer.fullName"
                        @update:modelValue="
                          (newValue) => (selectedCustomer.fullName = newValue)
                        "
                        :rules="{ required: true}"
                        id="text-fullName"
                        name="text-fullName"
                        :label="translate('fullName')"
                        class="mb-1 mr-sm-2"
                        description="text-fullName-feedback"
                        validatorName="Full Name"
                      />
                    </b-col>
                     <b-col
                      md="12"
                      style="justify-content: center; align-items: center"
                    >
                      <Vinput
                        inputType="text"
                        :modelValue="selectedCustomer.email"
                        @update:modelValue="
                          (newValue) => (selectedCustomer.email = newValue)
                        "
                        :rules="{regex:/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/}"
                        id="text-email"
                        name="text-email"
                        :label="translate('email')"
                        class="mb-1 mr-sm-2"
                        description="text-email-feedback"
                        validatorName="Email"
                      />
                    </b-col>
                    <b-col
                      md="12"
                      style="justify-content: center; align-items: center"
                    >
                       <Vselect
                        :modelValue="selectedCustomer.sex"
                        @update:modelValue="
                          (newValue) => (selectedCustomer.sex = newValue)
                        "
                          :options="sexOptions"
                        :rules="{ required: true }"
                        id="text-sex"
                        name="text-sex-options"
                        :label="translate('sex')"
                        class="mb-1 mr-sm-2 some-select"
                        description="text-sex-feedback"
                        validatorName="Sex"
                      />
                    </b-col>
                     <b-col
                      md="12"
                      style="justify-content: center; align-items: center"
                    >
                    <VinputGroup
                        inputType="text"
                        :modelValue="selectedCustomer.phoneNumber"
                        @update:modelValue="
                          (newValue) => (selectedCustomer.phoneNumber = newValue)
                        "
                        :rules="{ required: true, regex:/^\d{9}$/ }"
                        id="text-phoneNumber"
                        name="text-phoneNumber"
                        :label="translate('phoneNumber')"
                        class="mb-1 mr-sm-2"
                        description="text-phoneNumber-feedback"
                        validatorName="Phone Number"
                        prepend="+251"
                      />
                     </b-col>
                      <b-col
                      md="12"
                      style="justify-content: center; align-items: center"
                    >
                   <Vinput
                        inputType="text"
                        :modelValue="selectedCustomer.address"
                        @update:modelValue="
                          (newValue) => (selectedCustomer.address = newValue)
                        "
                        :rules="{ required: false }"
                        id="text-address"
                        name="text-address"
                        :label="translate('address')"
                        class="mb-1 mr-sm-2"
                        description="text-address-feedback"
                        validatorName="Address"
                      />
                     </b-col>
                     <b-col
                      md="12"
                      style="justify-content: center; align-items: center"
                    >
                   <Vinput
                        inputType="text"
                        :modelValue="selectedCustomer.job"
                        @update:modelValue="
                          (newValue) => (selectedCustomer.job = newValue)
                        "
                        :rules="{ required: false }"
                        id="text-job"
                        name="text-job"
                        :label="translate('job')"
                        class="mb-1 mr-sm-2"
                        description="text-job-feedback"
                        validatorName="Job"
                      />
                     </b-col>
                     <b-col
                      md="12"
                      style="justify-content: center; align-items: center"
                    >
                   <Vinput
                        inputType="text"
                        :modelValue="selectedCustomer.idNumber"
                        @update:modelValue="
                          (newValue) => (selectedCustomer.idNumber = newValue)
                        "
                        :rules="{ required: false }"
                        id="text-idNumber"
                        name="text-idNumber"
                        :label="translate('idNumber')"
                        class="mb-1 mr-sm-2"
                        description="text-idNumber-feedback"
                        validatorName="ID Number"
                      />
                     </b-col>
                     <b-col
                      md="12"
                      style="justify-content: center; align-items: center"
                    >
                   <Vinput
                        inputType="text"
                        :modelValue="selectedCustomer.description"
                        @update:modelValue="
                          (newValue) => (selectedCustomer.description = newValue)
                        "
                        :rules="{ required: false }"
                        id="text-description"
                        name="text-description"
                        :label="translate('description')"
                        class="mb-1 mr-sm-2"
                        description="text-description-feedback"
                        validatorName="Description"
                      />
                     </b-col>
                    <b-col class="mt-2">
                      <b-button type="submit" variant="primary">{{ translate('submit') }}</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </validation-observer>
            </b-modal>
        </div>
        <div class="row mt-3">
          <div class="col-12">
            <card class="strpied-tabled-with-hover"
                  body-classes="table-full-width table-responsive"
            >
                 <template slot="header">
                <b-row>
                <b-col lg="8" class="my-1">
                  <b-button v-if="modulePermission.create == 1" @click="AddCustomer()" class="btn-outline-primary">
                    <b-icon class="text-center" icon="plus"></b-icon> {{ translate('newMember') }}
                  </b-button>
                </b-col>
                <!-- <b-col lg="4" class="my-1">
              <b-button v-if="modulePermission.create === 1" @click="triggerFileInput" class="btn-outline-primary">
                <b-icon class="text-center" icon="plus"></b-icon> {{ translate('addBulkData') }}
              </b-button>
            </b-col> -->
               <b-col lg="4" class="my-1">
                    <b-form-group class="mb-0">
                      <b-input-group size="sm">
                        <b-form-input
                          id="filter-input"
                          v-model="filter"
                          type="search"
                          placeholder="Filter"
                        ></b-form-input>
  
                        <b-input-group-append>
                          <b-button class="btn-secondary" :disabled="!filter" @click="filter = ''"
                            >Clear</b-button
                          >
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                 
                </b-row>
              </template>
              <div class="table-container">
              <b-table-simple
                :small="true"
                sticky-header
                style="max-height: 395px;"
                striped
                responsive
                hover
              >
                <b-thead class="sticky-header">
                  <b-tr>
                    <b-th>{{ translate('no') }}</b-th>
                    <b-th>{{ translate('memberName') }}</b-th>
                    <b-th>{{ translate('phoneNumber') }}</b-th>
                    <b-th>{{ translate('email') }}</b-th>
                    <b-th>{{ translate('address') }}</b-th>
                    <b-th>{{ translate('job') }}</b-th>
                    <b-th>{{ translate('idNumber') }}</b-th>
                    <b-th>{{ translate('status') }}</b-th>
                    <b-th>{{ translate('description') }}</b-th>
                    <b-th>{{ translate('createdAt') }}</b-th>
                    <b-th>{{ translate('createdBy') }}</b-th>
                    <b-th sticky-column style="height: 45px;"></b-th>
                  </b-tr>
                </b-thead>
                <template v-if="spinner">
                  <b-tbody class="text-center">
                     <b-tr >
                         <b-td colspan="9" class="text-center" style="display: table-cell">
                          <b-spinner
                          style="height: 3rem; width: 3rem;"
                            variant="warning"
                          ></b-spinner>
                         </b-td>
                      </b-tr>
                  </b-tbody>
                </template>
                <template v-else>
                  <b-tbody>
                    <template v-if="filterTable.length === 0">
                        <b-tr>
                          <b-td colspan="9" class="text-center">Nothing found</b-td>
                          <b-td></b-td>
                        </b-tr>
                    </template>
                    <template v-else>
                      <b-tr
                        v-for="(item, index) in filterTable"
                        :key="item.ID"
                      >
                          <b-td>{{(currentPage - 1) * perPage + index + 1}}</b-td>
                          <b-td>{{item.fullName}}</b-td>
                          <b-td>{{item.phoneNumber}}</b-td>
                          <b-td>{{item.email}}</b-td>
                          <b-td>{{item.address}}</b-td>
                          <b-td>{{item.job}}</b-td>
                          <b-td>{{item.idNumber}}</b-td>
                          <b-td>{{item.status}}</b-td>
                          <b-td>{{item.description}}</b-td>
                          <b-td>{{item.createdDate}}</b-td>
                          <b-td>{{item.registeredBy}}</b-td>
                          <b-td sticky-column>
                          <b-row>
                     
                            <b-col md="4" class="mb-2" v-if="modulePermission.update == 1">
                              <b-icon icon="pencil-square" class="btn-icon" :title="translate('editMember')" @click="EditCustomer(item.customerId)" aria-hidden="true" ></b-icon>
                            </b-col>
                     
                          </b-row>
                        </b-td>
                      </b-tr>
                    </template>
                  </b-tbody>
                </template>
              </b-table-simple>
            </div>
               <!-- Pagination outside the table to prevent overlap -->
            <div class="pagination-container">
              <b-row class="mt-3 align-items-center justify-content-between">
                <b-col class="d-flex align-items-center">
                  <label class="mr-2 mb-0">{{ translate('recordsPerPage') }}</label>
                  <b-form-select
                    id="input-horizontal"
                    class="custom-dropdown"
                    v-model="perPage"
                    :options="pageOptions"
                    @change="changePerPage"
                  >
                  </b-form-select>
                </b-col>
                <b-col class="d-flex justify-content-end">
                  <b-pagination
                    v-model="currentPage"
                    :per-page="perPage"
                    :total-rows="totalRows"
                    @page-click="changePage"
                    align="right"
                  />
                </b-col>
              </b-row>
            </div>
             </card>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
    import LTable from 'src/components/Table.vue'
    import Card from 'src/components/Cards/Card.vue'
    import Vinput from 'src/components/Inputs/Vinput.vue'
    import VinputNumber from 'src/components/Inputs/VinputNumber.vue'
    import Vselect from 'src/components/Inputs/Vselect.vue'
    import VinputGroup from 'src/components/Inputs/VinputGroup.vue'
    import * as XLSX from 'xlsx';
    import { setLanguage, translate } from 'src/i18n.js';
    export default {
      components: {
        LTable,
        Card,
        Vinput,
        VinputNumber,
        Vselect,
        VinputGroup
      },
      data () {
        return {
          file: null,
          loading: false, // New loading state
          file: null,
          selectedFile: null,  // Holds the file selected by the user
          fileSelected: false, // Tracks if a file has been selected
          modulePermission: {
            view: 1,
            create: 0,
            update: 0,
            delete: 0
          },
          totalRows: 0,
          currentPage: 1,
          perPage: 7,
          pageOptions: [
            {value: 7, text: 7},
            {value: 10, text: 10},
            {value: 25, text: 25},
            {value: 50, text: 50},
            {value: 100, text: 100}
          ],
          sexOptions:[{value:"Male",text:translate("male")},
          {value:"Female",text:translate("female")}
          ],
          items: [],
          buildingOptions: [],
          ekubTypeOptions: [],
          numberOfEkubOptions: [
            {text: translate("One"), value: 1},
            {text: translate("Two"), value: 2},
            {text: translate("Three"), value: 3},
            {text: translate("Four"), value: 4},
            {text: translate("Five"), value: 5}
          ],
          addData: {
            numberOfEkub:null,
            fullName: "",
            email: "",
            sex: "",
            phoneNumber: "",
            address: "",
            user:{
              id: sessionStorage.getItem("ID")
            },
            userId: sessionStorage.getItem("ID"),
            job: "",
            idNumber: "",
            description: "",
            registeredBy:"",
            ekubId:null,
            linkingDescription:"",
            memberDescription:"",
            ekubType:null,
            associationId:null,
          },
           addFamily: {
            tenantId:null,
            familyType:"",
            fullName: "",
            email: "",
            sex:"",
            phoneNumber: "",
            address: "",
            user:{
              id: sessionStorage.getItem("ID")
            },
            registeredBy:""
          },
          filter: "",
          selectedCustomer:{},
          selectedTenant1: {
              tenatId: null,
              ContractInformation: [],
              paymentInformation: [],
              familyInformation: [],
              TotalAmountForHouse: 0,
            },
          spinner: true
        }
      },
      computed: {
        getEkubTypeName() {
    var ekubName = "";
    var value = this.addData.ekubId;
    if (value !== null && value !== "" && value !== 0) {
      const selectedEkub = this.ekubTypeOptions.find(item => item.value == value);
      ekubName = selectedEkub ? selectedEkub.text : "";
    }
    return ekubName;
  },
        filterTable() {
          var searchItems = this.items;
          var searchString = this.filter;
          if (searchString === "") {
            return searchItems;
          }
          searchString = searchString.trim().toLowerCase();
  
          searchItems = searchItems.filter(function (item) {
            if (item.fullName.toLowerCase().indexOf(searchString) !== -1 ||  item.phoneNumber.toLowerCase().indexOf(searchString) !== -1 || item.email.toLowerCase().indexOf(searchString) !== -1 || item.address.toLowerCase().indexOf(searchString) !== -1 ) {
              return item;
            }
          });
          return searchItems;
        },
      },
       mounted() {
        this.getEkubsByOwnerID();
        this.getModules();
        this.getCustomerByOwnerID();
        this.$on("AfterComplete", () => {
          this.getCustomerByOwnerID();
          this.getEkubsByOwnerID();
        });
      },
      methods: {
        translate,
      changeLanguage(lang) {
        setLanguage(lang);
        this.$forceUpdate();
      },
    // Trigger file input (when Add Bulk Data button is clicked)
    triggerFileInput() {
        this.$bvModal.show('modal-top-add-bulk');
      },
  
      // Handle file selection
      onFileSelected(file) {
        if (!file) {
          this.file = null;
          alert('No file selected.');
          return;
        }
        this.file = file;
        console.log('File selected:', file.name); // Debugging
      },
  
      // Confirm and submit file
      confirmAndSubmitFile() {
        this.$bvModal
          .msgBoxConfirm(translate('areYouSureYouWantToSubmitThisForm'), {
            title: translate('confirm'),
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'success',
            cancelVariant: 'danger',
            okTitle:  translate('yes'),
            cancelTitle: translate('nono'),
            bodyClass: 'm-2',
            hideHeaderClose: false,
            centered: false,
          })
          .then((confirmed) => {
            if (confirmed) {
              this.submitFile();
            }
          })
          .catch((err) => {
            console.error('Modal closed without confirmation:', err);
          });
      },
  
      // Submit the file (parse and send to API)
    submitFile() {
      if (!this.file) {
        alert('Please select a file before submitting.');
        return;
      }
      this.loading = true; // Set loading to true
      const fileExtension = this.file.name.split('.').pop().toLowerCase();
  
      if (fileExtension === 'csv') {
        this.parseCSV(this.file);
      } else if (fileExtension === 'xls' || fileExtension === 'xlsx') {
        this.parseExcel(this.file);
      } else {
        alert('Please upload a CSV or Excel file.');
        this.loading = false; // Set loading to true
      }
    },
  
     // Parse CSV file without external library
    parseCSV(file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const fileContent = event.target.result;
        console.log('CSV file content:', fileContent);  // Debugging
  
        // Manually parse the CSV data
        const parsedData = this.csvToJson(fileContent);
  
        // Map the CSV data to the expected JSON format
        const jsonData = this.mapDataToJson(parsedData);
        this.sendDataToAPI(jsonData);
      };
      reader.readAsText(file);
    },
    // Convert CSV to JSON format
    csvToJson(csv) {
      const lines = csv.split('\n');
      const result = [];
      const headers = lines[0].split(','); // Assuming the first line is the header
  
      // Iterate over the remaining lines (data rows)
      for (let i = 1; i < lines.length; i++) {
        const currentLine = lines[i].split(',');
        if (currentLine.length === headers.length) { // Ensure the row matches the header length
          const obj = {};
          for (let j = 0; j < headers.length; j++) {
            obj[headers[j].trim()] = currentLine[j].trim();
          }
          result.push(obj);
        }
      }
  
      return result;
    },
  
      // Map data to JSON
      mapDataToJson(data) {
        return data.map((item) => ({
          user:{
          id: sessionStorage.getItem("ID")
          },
          userId: sessionStorage.getItem("ID"),
          phoneNumber: item['phoneNumber'],
          email: item['email'],
          fullName: item['fullName'],
          sex: item['sex'],
          idNumber: item['idNumber'],
          job: item['job'],
          address: item['address'],
          description: item['description'],
          registeredBy: parseInt(sessionStorage.getItem("userID")),
        }));
      },
  
      // Send data to API
      sendDataToAPI(data) {
        console.log('Data to be sent to API:', data); // Debugging
        this.$store
          .dispatch('AddBulkMember', data)
          .then((response) => {
            console.log('API Response:', response); // Debugging
            this.$notifications.notify({
              message: `<span>Data uploaded successfully:</span>`,
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'success',
            });
            this.$bvModal.hide('modal-top-add-bulk');
            this.clearData();
            setTimeout(() => {
              location.reload();
            }, 2000); // Adjust delay as needed
          })
          .catch((error) => {
            console.error('API Error:', error); // Debugging
            this.$notifications.notify({
              message: (error.response && error.response.data) || 'Upload failed.',
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'danger',
            });
            this.clearData();
            setTimeout(() => {
              location.reload();
            }, 2000); // Adjust delay as needed
          });
      },
    // Download sample file
    downloadSampleFile() {
      const sampleData = [
        ['Number', 'phoneNumber', 'email', 'fullName', 'sex', 'idNumber', 'job', 'address', 'description'],
        [1,'922334455', 'abcd@example.com', 'Abebe Kebede', 'Male', '1234567890', 'Engineer', '123 Main St', 'Sample description'],
        [2,'911223344', 'abcdef@example.com', 'Aster Solomon', 'Female', 'ABCD_1234', 'Doctor', '456 Oak St', 'Sample description'],
      ];
  
      let csvContent = "data:text/csv;charset=utf-8,";
      sampleData.forEach((rowArray) => {
        const row = rowArray.join(',');
        csvContent += row + '\r\n';
      });
  
      const encodedUri = encodeURI(csvContent);
      const link = document.createElement('a');
      link.setAttribute('href', encodedUri);
      link.setAttribute('download', 'sample-file.csv');
      link.click();
    },
         getModules(){
          this.$store.dispatch('getModulesPermission', {userId: sessionStorage.getItem("userID")})
            .then(response=>{
                //this.items = response.data;
                var modulesList = response.data.modules;
                var CustomerModule = modulesList.filter(x=>x.name === "Members_Super");
                if(CustomerModule !== null){
                  this.modulePermission.view = CustomerModule[0].listData;
                  this.modulePermission.create = CustomerModule[0].createData;
                  this.modulePermission.update = CustomerModule[0].updateData;
                  this.modulePermission.delete = CustomerModule[0].deleteData;
                }
            })
            .catch(error=>{
                //console.log(error);
            })
        },
        getEkubsByOwnerID() {
    this.$store.dispatch('getAllAssociationDashboard', { userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID"))})
      .then(response => {
        this.ekubTypes = response.data;  // Assuming 'response.data' is the array of ekub objects
        // console.log("getAll",response.data);
        this.ekubTypeOptions = this.ekubTypes.map(ekub => ({
          value: ekub.id,            // 'value' for Vselect
          text: ekub.ekubName,       // 'text' for Vselect
          ekubType: ekub.ekubType,   // The ekubType for potential use
          ekubAmount: ekub.ekubAmount, // Amount for calculated display
          numberOfEkuber: ekub.numberOfEkuber, // Number of members for display
          cycle: ekub.cycle,         // Cycle duration for calculated display
          cycleDuration: ekub.cycleDuration // Cycle duration for calculated display
        }));
      })
      .catch(error => {
        this.$notify({
          title: 'Error',
          text: error.response.data,
          type: 'error'
        });
      });
  },
        getCustomerByOwnerID(){
          this.spinner = true;
            this.$store.dispatch('getAllMembers', {userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID")), page: this.currentPage, line: this.perPage})
            .then(response=>{
              this.items = response.data.Contents;
              this.totalRows = response.data.totalElements;
            })
            .catch(error=>{
                //console.log(error);
            })
            .finally(msg=>{
              this.spinner =false;
            })
        },
        changePage(event, page){
          this.spinner = true;
          this.$store.dispatch('getAllMembers', {userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID")), page: page, line: this.perPage})
            .then(response=>{
                this.items = response.data.Contents;
                this.totalRows = response.data.totalElements;
            })
            .catch(error=>{
                // this.$notify({
                //     title: 'Error',
                //     text: error.response.data,
                //     type: 'error'
                // })
                //console.log(error);
            })
            .finally(msg=>{
              this.spinner =false;
            })
        },
        changePerPage(event){
          this.spinner = true;
          this.$store.dispatch('getAllMembers', {userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID")), page: this.currentPage, line: this.perPage})
            .then(response=>{
                this.items = response.data.Contents;
                this.totalRows = response.data.totalElements;
            })
            .catch(error=>{
                // this.$notify({
                //     title: 'Error',
                //     text: error.response.data,
                //     type: 'error'
                // })
                //console.log(error);
            })
            .finally(msg=>{
              this.spinner =false;
            })
        },
        AddCustomer(){
          this.$bvModal.show('modal-top-add');
        },
        submitAddForm(){
              this.$bvModal.msgBoxConfirm(translate('areYouSureYouWantToSubmitThisForm'), {
                  title: translate('confirm'),
                   size: 'sm',
                   buttonSize: 'sm',
                   okVariant: 'success',
                   cancelVariant: 'danger',
                   okTitle:  translate('yes'),
                  cancelTitle: translate('nono'),
                   bodyClass: 'm-2',
                   hideHeaderClose: false,
                   centered: false
               })
               .then(value => {
                   if(value === true){
                      this.$store.dispatch('AddMembersForSuperWithLinking', {
                        ekubId: this.addData.associationId,
                        fullName: this.addData.fullName,
                        email: this.addData.email,
                        sex: this.addData.sex,  
                        phoneNumber: "+251"+this.addData.phoneNumber,
                        address: this.addData.address,
                        user:{
                          id: sessionStorage.getItem("ID")
                        },
                        userId: sessionStorage.getItem("ID"),
                        job: this.addData.job,
                        idNumber: this.addData.idNumber,
                        description: this.addData.description,
                        linkingDescription: this.addData.linkingDescription,
                        ekubTypeDescription: this.addData.ekubTypeDescription,
                        memberDescription: this.linkingDescription,
                        numberOfEkub: this.addData.numberOfEkub,
                        registeredBy: parseInt(sessionStorage.getItem("userID")),
                        superUserId: parseInt(sessionStorage.getItem("superID"))
                      })
                      .then(response=>{
                          this.$notifications.notify(
                            {
                              message: `<span>Members successfully created.</span>`,
                              horizontalAlign: 'center',
                              verticalAlign: 'top',
                              type: 'success'
                            })
                            this.$bvModal.hide('modal-top-add');
                            this.clearData();
                      })
                      .catch(error=>{
                           this.$notifications.notify(
                            {
                              message: error.response.data,
                              horizontalAlign: 'center',
                              verticalAlign: 'top',
                              type: 'danger'
                            })
                            //console.log(error);
                      })
                   }
               })
               .catch(error=>{
                    //console.log(error)
               })
        },
        EditCustomer(ID){
        //console.log("some of", this.items);
          var customer= this.items.filter(item=> item.customerId == ID)[0];
          this.selectedCustomer.customerId = customer.customerId
          this.selectedCustomer.fullName = customer.fullName;
          this.selectedCustomer.email = customer.email;
          this.selectedCustomer.sex = customer.sex;
          this.selectedCustomer.address = customer.address;
          this.selectedCustomer.job = customer.job;
          this.selectedCustomer.idNumber = customer.idNumber;
          this.selectedCustomer.description = customer.description;
          if(customer.phoneNumber.startsWith("+251")){
            var some = customer.phoneNumber.slice(4,13);
            this.selectedCustomer.phoneNumber = some;
          } 
          if(customer.phoneNumber.startsWith("09")){
            var some = customer.phoneNumber.slice(1,10);
            this.selectedCustomer.phoneNumber = some;
          }
          this.$bvModal.show('modal-top-EditCustomer');
        },
        submitEditForm(){
          this.$bvModal.msgBoxConfirm(translate('areYouSureYouWantToSubmitThisForm'), {
              title: translate('confirm'),
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'success',
              cancelVariant: 'danger',
              okTitle:  translate('yes'),
              cancelTitle: translate('nono'),
              bodyClass: 'm-2',
              hideHeaderClose: false,
              centered: false
          })
          .then(value => {
              if(value === true){
                this.$store.dispatch('EditCustomer', {
                  id: this.selectedCustomer.customerId,
                  fullName : this.selectedCustomer.fullName,
                  email : this.selectedCustomer.email,
                  sex : this.selectedCustomer.sex,
                  address : this.selectedCustomer.address,
                  job : this.selectedCustomer.job,
                  idNumber : this.selectedCustomer.idNumber,
                  description : this.selectedCustomer.description,
                  userId: sessionStorage.getItem("userID"),
                  phoneNumber : "+251"+this.selectedCustomer.phoneNumber
                })
                .then(response=>{
                    this.$notifications.notify(
                      {
                        message: `<span>Members information Successfully Updated.</span>`,
                        horizontalAlign: 'center',
                        verticalAlign: 'top',
                        type: 'success'
                      })
                      this.$bvModal.hide('modal-top-EditCustomer');
                      this.clearData();
                })
                .catch(error=>{
                  //console.log(error);
                  this.$notifications.notify(
                      {
                        message: error.response.data,
                        horizontalAlign: 'center',
                        verticalAlign: 'top',
                        type: 'danger'
                      })
                    //console.log(error);
                })
              }
          })
          .catch(error=>{
              //console.log(error)
          })
        },
        AddFamily(ID){
        //console.log("some of", this.items);
        this.addFamily.tenantId = this.items.filter(item=> item.tenantId == ID)[0].tenantId
          var tenant= this.items.filter(item=> item.tenantId == ID)[0];
          //console.log("items ",this.items.filter(item=> item.tenantId == ID)[0]);
          this.$bvModal.show('modal-top-AddFamily');
        },
        submitAddFamilyForm(){
          this.$bvModal.msgBoxConfirm(translate('areYouSureYouWantToSubmitThisForm'), {
              title: translate('confirm'),
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'success',
              cancelVariant: 'danger',
              okTitle:  translate('yes'),
              cancelTitle: translate('nono'),
              bodyClass: 'm-2',
              hideHeaderClose: false,
              centered: false
          })
          .then(value => {
              if(value === true){
                this.$store.dispatch('AddFamily', {
                  tenants:{
                  tenantId: this.addFamily.tenantId
                  },
                  familyType:this.addFamily.familyType,
                  fullName : this.addFamily.fullName,
                  email : this.addFamily.email,
                  sex : this.addFamily.sex,
                  address : this.addFamily.address,
                  registeredBy: parseInt(sessionStorage.getItem("userID")),
                  phoneNumber : "+251"+this.addFamily.phoneNumber
                })
                .then(response=>{
                    this.$notifications.notify(
                      {
                        message: `<span>Tenant Family information Successfully Added.</span>`,
                        horizontalAlign: 'center',
                        verticalAlign: 'top',
                        type: 'success'
                      })
                      this.$bvModal.hide('modal-top-AddFamily');
                      this.clearData();
                })
                .catch(error=>{
                  //console.log(error);
                  this.$notifications.notify(
                      {
                        message: error.response.data,
                        horizontalAlign: 'center',
                        verticalAlign: 'top',
                        type: 'danger'
                      })
                    //console.log(error);
                })
              }
          })
          .catch(error=>{
              //console.log(error)
          })
        },
         ViewDetail(ID){
          this.$store.dispatch('getDetailTenant', {tenantId: ID})
          .then(response=>{
            this.selectedTenant1 = response.data;
            //console.log("some", response.data);
              this.$bvModal.show('modal-top-Details');
              this.clearData();
          })
          .catch(error=>{
            this.$notifications.notify(
                {
                  message: error.response.data,
                  horizontalAlign: 'center',
                  verticalAlign: 'top',
                  type: 'danger'
                })
              //console.log(error);
          })
        },
        clearData(){
          this.ekubTypeOptions = [];
          this.addData.fullName = this.addData.email = this.addData.phoneNumber = this.addData.address = this.addData.sex = this.addData.description  = this.addData.idNumber = this.addData.job = "";
          this.addFamily.familyType = this.addFamily.fullName = this.addFamily.email = this.addFamily.phoneNumber = this.addFamily.address = this.addFamily.sex = "";
          this.selectedFile = null;
          this.fileSelected = false;
          this.file = null;
          this.$refs.fileInput && this.$refs.fileInput.reset();
          this.$emit('AfterComplete');
        },
      closeModal() {
      this.$bvModal.hide('modal-top-add-bulk');
      this.clearData();
    },
      }
    }
  </script>
  <style lang="scss" scoped>
  .b-table-sticky-column:last-child {
      right: 0;
    }
  .text-warning {
      color: rgba(240, 206, 13, 0.937) !important;
    }
  .btn-icon{
    font-size: 27px !important;
    padding: 3px 5px 3px 5px;
    width: 40px;
    color:  rgb(37, 91, 48);
    border: 2px solid rgb(37, 91, 48);
  }
  .btn-icon:hover,
  .btn-icon:focus {
    cursor: pointer;
    background-color: rgb(37, 91, 48) !important;
    color: rgba(240, 206, 13, 0.937) !important;
    border-radius: 4px;
    transition: .4s;
  }
  .table-container {
  display: flex;
  flex-direction: column;
  max-height: calc(80vh - 0px); /* Adjust depending on other UI elements */
  overflow-y: auto;
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

/* Mobile adjustments */
@media (max-width: 768px) {
  .custom-dropdown {
    max-width: 100%; /* Ensure dropdown expands on mobile */
  }

  .pagination-container {
    margin-top: 20px;
  }

  .table-container {
    max-height: 50vh; /* Lower height for better mobile usability */
  }

  .b-button-toolbar {
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  .b-button {
    padding: 8px;
    margin: 5px;
  }
  .table-container {
  max-height: 50vh;
  overflow-y: auto;
  overflow-x: auto;
}
}
.sticky-header {
  position: sticky;
  top: 0;
  background-color: #fff; /* Ensure header has a background */
  z-index: 1; /* Ensure it stays on top of the table body */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); /* Optional: Add shadow for better visibility */
}
  </style>